<template>
  <div class="homeBox">
    <!-- 顶部图片 -->
    <Banner @clickSolution="clickSolution" />

    <!-- 实验室安全生态 -->
    <LibraryEcology />

    <!-- 方案场景 -->
    <div class="homeWrap mainBox" ref="solutionRef">
      <div class="title" style="text-align: center">
        <div class="text1">方案场景</div>
        <div class="text2">提供丰富、安全、稳定、智能的产品及服务方案</div>
      </div>
      <menus-check></menus-check>
    </div>

    <!-- AI产品 -->
    <AIProduct />

    <!-- 软件产品 -->
    <SoftProduct />

    <!-- 物联产品 -->
    <Product></Product>

    <!-- 图表 -->
    <div class="homeWrap mainBox">
      <div class="title" style="text-align: center">
        <div class="text1">行业领先智能安全管控平台</div>
        <div class="text2">多维度数据全景呈现,见证企业发展实力</div>
      </div>
      <div class="chartBox" ref="chartBoxRef">
        <Chart ref="chartRef"></Chart>
      </div>
    </div>

    <!-- 客户案例 -->
    <Examples />

    <!-- 新闻 -->
    <news></news>
  </div>
</template>

<script lang="ts" setup>
import imageUrl from "@/utils/oss";
import Banner from "./components/banner.vue";
import news from "./components/news.vue";
import SoftProduct from "./components/softProduct.vue";
import Product from "./components/product.vue";
import AIProduct from "./components/aiProduct.vue";
import menusCheck from "./components/menusCheck";
import Chart from "./components/chart.vue";
import Examples from "./components/examples.vue";
import { ref, onMounted, nextTick, onUnmounted } from "vue";
import { WOW } from "wowjs";
import HomeApi from "@/api/homeApi.js";
import { navTo } from "@/utils/util";
import LibraryEcology from "./components/libraryEcology.vue";
const homeApi = new HomeApi();

const chartBoxRef = ref(null);
const chartRef = ref(null);
const chartPositionTop = ref(0);

//解决方案
const solutionRef = ref(null);
const solutionTop = ref(0);

//悬浮按钮是否固定
const isFixed = ref(false);

onUnmounted(() => {
  window.removeEventListener("scroll", handleScroll);
});

onMounted(() => {
  //初始化wow
  const wow = new WOW();
  wow.init();

  //获取定位
  getPostion();

  //监听页面滚动事件
  window.addEventListener("scroll", handleScroll);
});

//计算定位
const getPostion = () => {
  setTimeout(() => {
    if (chartBoxRef.value) {
      const rect = chartBoxRef.value.getBoundingClientRect();
      chartPositionTop.value = rect.top - document.body.clientHeight;
      // console.log("rect", rect); // 输出位置和尺寸信息
    }

    //获取元素高度
    if (solutionRef.value) {
      const rect = solutionRef.value.getBoundingClientRect();
      solutionTop.value = rect.top - document.body.clientHeight;
    }
  }, 1000);
};

//处理滚动事件
const handleScroll = (event) => {
  //展示图表动画
  if (
    window.scrollY >= chartPositionTop.value &&
    window.scrollY >= chartPositionTop.value + 500
  ) {
    chartRef.value?.animate();
  }

  //如果滚动超过悬浮按钮高度，悬浮按钮就固定
  if (window.scrollY >= 640) {
    isFixed.value = true;
  } else {
    isFixed.value = false;
  }
};

/**
 * 点击行业解决方案
 */
const clickSolution = () => {
  window.scrollTo({
    top: solutionTop.value + document.body.clientHeight - 50,
    behavior: "smooth",
  });
};
</script>

<style lang="scss" scoped>
.homeBox{
}

.homeWrap {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.chartBox {
  width: 100%;
}
</style>
